export default () => ({
  disciplines: [],
  status: {
    loading: false,
    error: false,
  },
  buttonLoading: false,
});
